export const FilterTypes = {
  MODULE_STATUS: 'modulestatus'
}

export const ModuleGroupTypes = {
  PROGRAM: 'program',
  ELECTIVE: 'modulegroup'
}
